var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.04574 20.5618C9.31809 19.2895 9.31808 17.2266 8.04574 15.9543C6.7734 14.6819 4.71053 14.6819 3.43819 15.9543C2.57033 16.8221 2.17184 19.3643 2.00618 20.8929C1.93656 21.5353 2.46469 22.0634 3.10709 21.9938C4.63572 21.8282 7.17789 21.4297 8.04574 20.5618Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 14.75C15.7574 14.75 14.75 15.7574 14.75 17C14.75 18.2426 15.7574 19.25 17 19.25C18.2426 19.25 19.25 18.2426 19.25 17C19.25 15.7574 18.2426 14.75 17 14.75ZM18 17C18 17.5523 17.5523 18 17 18C16.4477 18 16 17.5523 16 17C16 16.4477 16.4477 16 17 16C17.5523 16 18 16.4477 18 17Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22C19.7614 22 22 19.7614 22 17C22 14.2386 19.7614 12 17 12C14.2386 12 12 14.2386 12 17C12 19.7614 14.2386 22 17 22ZM13.25 17C13.25 14.9289 14.9289 13.25 17 13.25C19.0711 13.25 20.75 14.9289 20.75 17C20.75 19.0711 19.0711 20.75 17 20.75C14.9289 20.75 13.25 19.0711 13.25 17Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5642 16.0827C11.01 12.9272 13.7215 10.5 17 10.5C17.8008 10.5 18.5677 10.6448 19.2761 10.9097C21.2611 8.78922 22.2419 5.91911 21.9491 3.05039C21.895 2.52017 21.4798 2.10502 20.9496 2.05091C17.9707 1.74685 14.9903 2.81614 12.8494 4.95706L10.8749 6.93154L9.63049 6.3179L9.09513 6.09247C8.10232 5.67442 6.94392 5.90769 6.17012 6.68149L4.13244 8.71917C3.90931 8.9423 3.97801 9.31615 4.26429 9.4367L5.84576 10.1026L7.09019 10.7163L6.71649 11.09C6.40032 11.4061 6.39567 11.9141 6.70612 12.2245L10.5642 16.0827Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketTarget);
export default __webpack_public_path__ + "static/media/rocket-target.75600b505061fd19b9d207013a7e35cf.svg";
export { ForwardRef as ReactComponent };